import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import api from '../../lib/api';
import { toast } from 'sonner';

/**
 * Platform Admin area wrapper.
 *
 * The primary navigation (the 7-section Platform Admin sidebar) lives in the
 * shared layout `Sidebar` component, which swaps to admin mode whenever the
 * route is under /dashboard/admin. This wrapper therefore only enforces the
 * server-side admin authorisation guard and renders the active admin page.
 * Seller navigation is never mixed into the admin sidebar.
 */
export default function AdminLayout() {
  const navigate = useNavigate();
  const [me, setMe] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    // `/admin/me` returns 403 for non-admins; bounce them back to the dashboard.
    api.get('/admin/me').then(({ data }) => setMe(data)).catch(() => {
      toast.error('Admin access required');
      navigate('/dashboard', { replace: true });
    }).finally(() => setChecking(false));
  }, [navigate]);

  if (checking) return <div className="p-6 text-fab-text-muted">Verifying admin access…</div>;
  if (!me) return null;

  return (
    <div className="min-w-0" data-testid="admin-layout">
      <Outlet />
    </div>
  );
}
